import { render } from "./MemberSelection.vue?vue&type=template&id=2dde3022&scoped=true"
import script from "./MemberSelection.vue?vue&type=script&lang=js"
export * from "./MemberSelection.vue?vue&type=script&lang=js"

import "./MemberSelection.vue?vue&type=style&index=0&id=2dde3022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dde3022"]])

export default __exports__